<template>
  <div class="progress-bar">
    <div class="progress-bar-text"> Loading ... {{percentProgress.toFixed(0)}}% </div>
      <span class="progress-bar-progress">
        <span class="progress-bar-progress-percent" :style="`width: ${percentProgress}%`"></span>
      </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "progressBar",
  computed: {
    percentProgress() {
      return this.$store.state.preloader.percentProgress;
    },
  },
}
</script>